import { m, AnimatePresence } from "framer-motion";
import { X, MapPin } from "lucide-react";
import QuoteForm from "@/components/QuoteForm";

export default function QuoteModal({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <m.div
          className="fixed inset-0 z-[100] flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="quote-modal"
        >
          <div
            className="absolute inset-0 bg-slate-900/70 backdrop-blur-sm"
            onClick={onClose}
          />
          <m.div
            className="relative z-10 max-h-[92vh] w-full max-w-md overflow-y-auto rounded-2xl border-2 border-[#F97316] bg-white p-5 shadow-2xl sm:p-8"
            initial={{ opacity: 0, scale: 0.94, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.94, y: 20 }}
            transition={{ type: "spring", damping: 24, stiffness: 300 }}
          >
            <button
              onClick={onClose}
              className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700"
              data-testid="quote-modal-close"
            >
              <X className="h-5 w-5" />
            </button>
            <div className="mb-1.5 flex items-center gap-1.5 text-sm font-bold text-[#0F172A] sm:mb-2" data-testid="modal-service-area">
              <MapPin className="h-4 w-4" fill="currentColor" /> Southern California
            </div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#F97316] sm:text-sm">
              Free Estimate
            </p>
            <h3 className="font-heading mt-1 mb-3 text-xl font-extrabold text-[#0F172A] sm:mb-5 sm:text-2xl">
              Claim Your FREE Painting Quote
            </h3>
            <QuoteForm variant="light" testPrefix="modal" compact />
          </m.div>
        </m.div>
      )}
    </AnimatePresence>
  );
}
